export default __webpack_public_path__ + "static/media/icon-process.5cf9c69e.svg";